import KycIncidentService from "../../../services/KycIncidentService";

const actions = {
  GET_KYC_CASES(
    context,
    {
      filters,
      stateKey,
      serviceEntityId,
      sortBy,
      sortDirection,
      page,
      itemsPerPage,
      columnFilters,
      searchText,
      kycGroupIds,
      kycStateIds,
      responseCodes,
      assignedTo,
      exportOnly,
    },
  ) {
    if (!exportOnly) {
      context.commit("changeKycIncidentLoading", {
        isLoading: true,
        stateKey: stateKey,
      });
      context.commit("clearKycData", stateKey);
    }
    if (!serviceEntityId || filters == null) {
      if (!exportOnly) {
        context.commit("changeKycIncidentLoading", {
          isLoading: false,
          stateKey: stateKey,
        });
      }
      return Promise.resolve(null);
    }
    const payload = { ...filters };
    if (!payload.serviceEntityId) {
      payload.serviceEntityId = serviceEntityId;
    }
    if (sortBy) {
      payload.sortBy = sortBy;
    }
    if (sortDirection) {
      payload.sortDirection = sortDirection;
    }
    if (!exportOnly && page) {
      payload.page = page;
    }
    if (!exportOnly && itemsPerPage) {
      payload.itemsPerPage = itemsPerPage;
    }
    if (columnFilters && columnFilters.length > 0) {
      payload.columnFilters = columnFilters;
    }
    if (searchText) {
      payload.searchText = searchText;
    }
    if (kycGroupIds && kycGroupIds.length > 0) {
      payload.kycGroupIds = kycGroupIds;
    }
    if (kycStateIds && kycStateIds.length > 0) {
      payload.kycStateIds = kycStateIds;
    }
    if (responseCodes && responseCodes.length > 0) {
      payload.responseCodes = responseCodes;
    }
    if (assignedTo) {
      payload.assignedTo = assignedTo;
    }
    if (payload.queryList && payload.queryList.length) {
      payload.queryList = payload.queryList.map((q) => ({
        ...q,
        analysisId: Number(q.analysisId) || 0,
        analysisQueryNo: Number(q.analysisQueryNo) || 0,
      }));
    }
    return KycIncidentService.execute(payload)
      .then(({ data }) => {
        if (exportOnly) {
          return (data && data.result) || null;
        }
        context.commit("updateKycIncidents", {
          result: data.result,
          stateKey: stateKey,
        });
        return null;
      })
      .catch(() => {
        /* handled by global error middleware */ return null;
      })
      .finally(() => {
        if (!exportOnly) {
          context.commit("changeKycIncidentLoading", {
            isLoading: false,
            stateKey: stateKey,
          });
        }
      });
  },
};

export default actions;
